import React from 'react';
import Header from '../components/Header';

export default function RecipesDone() {
  return <Header title="Receitas Feitas" searchButton={ false } />;
}
